import { useContext, useEffect, createContext, useState, useCallback } from 'react';
import { tipseensAPI } from '../api';
import { useMondayContext } from './monday-context';

const TipseensContext = createContext(null);

export const TipseensProvider = ({ children }) => {
  const [tipseens, setTipseens] = useState({});
  const [isTipseensLoaded, setTipseensLoaded] = useState(false);
  const { sessionToken } = useMondayContext();

  useEffect(() => {
    let isSubscribed = true;
    const getTipseens = async () => {
      try {
        const { tipseens: fetchedTipseens } = await tipseensAPI.getTipseens({ sessionToken });
        if (!isSubscribed) return;
        setTipseens(fetchedTipseens);
        setTipseensLoaded(true);
      } catch {}
    };

    sessionToken && getTipseens();

    return () => (isSubscribed = false);
  }, [sessionToken]);

  const syncTipseen = useCallback(
    async (tipseenName) => {
      setTipseens([...tipseens, tipseenName]);
      await tipseensAPI.syncTipseen({ sessionToken, tipseenName });
    },
    [tipseens, sessionToken]
  );

  const isTipseenSynced = useCallback(
    (name) => {
      return tipseens.find((tipseenName) => tipseenName === name);
    },
    [tipseens]
  );

  return (
    <TipseensContext.Provider value={{ syncTipseen, isTipseenSynced, isTipseensLoaded }}>
      {children}
    </TipseensContext.Provider>
  );
};

export const useTipseens = () => {
  return useContext(TipseensContext);
};
